export const updateSelectedTicketAction = (state) => {
  return {
    type: "UPDATE_SELECTED_TICKET",
    payload: state,
  };
};
